import React from 'react';
import DecisionTreeEngine from './DecisionTreeEngine';

/**
 * LaunchTree - "Should I Launch While Rebuilding?" Decision Tree
 * 
 * A 7-gate linear decision tree using the DecisionTreeEngine.
 * Gate 04 has inverted logic (NO continues, YES exits).
 */

// Tree configuration
const treeConfig = {
  title: "Should I Launch While Rebuilding?",
  subtitle: "BINARY GAME DECISION TREE // MARCO // FEBRUARY 2026"
};

// Gate definitions - linear sequence
const allGates = [
  {
    id: "01",
    type: "YES/NO",
    question: "Am I regulated right now?",
    noText: "Pause. Regulate. Return to this decision when steady."
  },
  {
    id: "02",
    type: "THIS/THAT",
    question: "Is this launch coming from fear... or belief?",
    yesLabel: "BELIEF",
    noLabel: "FEAR",
    noText: "Separate the money problem from the product. Solve the cash pressure first."
  },
  {
    id: "03",
    type: "THIS/THAT",
    question: "Is my current financial state a skill issue... or a chapter?",
    yesLabel: "CHAPTER",
    noLabel: "SKILL ISSUE",
    noText: "Identify the actual capability gap before going public."
  },
  {
    id: "04",
    type: "YES/NO",
    question: "Does struggling disqualify someone from solving problems?",
    noText: "Examine that belief. Would you trust only people who've never struggled?",
    inverted: true // NO continues (struggling does NOT disqualify), YES exits
  },
  {
    id: "05",
    type: "YES/NO",
    question: "If someone else did this publicly, would I respect them?",
    noText: "What specific condition would need to change for you to respect it? Change that first."
  },
  {
    id: "06",
    type: "YES/NO",
    question: "Can I answer 'How are you qualified?' without defensiveness?",
    noText: "Write the honest answer. If it holds under pressure, return to this gate."
  },
  {
    id: "07",
    type: "THIS/THAT",
    question: "Would waiting increase integrity... or just reduce discomfort?",
    yesLabel: "REDUCE DISCOMFORT",
    noLabel: "INCREASE INTEGRITY",
    noText: "Name the integrity gap clearly. Fix it. Then return."
  }
];

// For a linear tree, getNextGates always returns the full gate sequence
const getNextGates = (currentGateIndex, answers) => {
  return allGates;
};

// Result is always the same for this linear tree
const getResult = (answers) => {
  return {
    text: "Launch. Lead visibly before your external metrics match your internal capacity."
  };
};

const LaunchTree = ({ onClose }) => {
  return (
    <DecisionTreeEngine
      treeConfig={treeConfig}
      getNextGates={getNextGates}
      getResult={getResult}
      onClose={onClose}
    />
  );
};

export default LaunchTree;
